module.exports = __webpack_public_path__ + "img/SES_205330060.edbd07e2.jpg";